import { useState, useEffect } from "react";
import "./CodingPuzzle.css";

export default function CodingPuzzle() {
  const [questions, setQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [userAnswer, setUserAnswer] = useState("");
  const [score, setScore] = useState(0);
  const [showResult, setShowResult] = useState(false);
  const [secondsLeft, setSecondsLeft] = useState(25);
  const [showExplanation, setShowExplanation] = useState(false);
  const [started, setStarted] = useState(false);

  const allQuestions = [
    // ================== EASY (100) ==================
  { q: "What does HTML stand for?", a: "HyperText Markup Language", e: "HTML is the basic structure of webpages.", level: "easy" },
  { q: "Largest heading tag?", a: "<h1>", e: "Headings go from <h1> to <h6>.", level: "easy" },
  { q: "Insert line break element?", a: "<br>", e: "Breaks text to a new line.", level: "easy" },
  { q: "Bold text tag?", a: "<b>", e: "Renders bold font.", level: "easy" },
  { q: "Preferred bold semantic tag?", a: "<strong>", e: "Indicates importance.", level: "easy" },
  { q: "HTML tag for images?", a: "<img>", e: "Used to insert images.", level: "easy" },
  { q: "HTML tag for hyperlink?", a: "<a>", e: "Used to create links.", level: "easy" },
  { q: "Attribute for image source?", a: "src", e: "Defines image source URL.", level: "easy" },
  { q: "Attribute to open link new tab?", a: "target=\"_blank\"", e: "Opens link in a new tab.", level: "easy" },
  { q: "HTML tag for unordered list?", a: "<ul>", e: "Creates bullet lists.", level: "easy" },
  { q: "HTML tag for ordered list?", a: "<ol>", e: "Creates numbered lists.", level: "easy" },
  { q: "HTML list item tag?", a: "<li>", e: "Item in a list.", level: "easy" },
  { q: "HTML table row tag?", a: "<tr>", e: "Defines a table row.", level: "easy" },
  { q: "HTML table cell tag?", a: "<td>", e: "Defines a table cell.", level: "easy" },
  { q: "HTML for checkbox?", a: "<input type=\"checkbox\">", e: "Creates a checkbox input.", level: "easy" },
  { q: "HTML for password input?", a: "<input type=\"password\">", e: "Hides entered characters.", level: "easy" },
  { q: "HTML element for navigation?", a: "<nav>", e: "Semantic navigation block.", level: "easy" },
  { q: "HTML tag for main content?", a: "<main>", e: "Represents main content.", level: "easy" },
  { q: "HTML tag for footer?", a: "<footer>", e: "Bottom section of page.", level: "easy" },
  { q: "HTML tag for form?", a: "<form>", e: "Container for form fields.", level: "easy" },
  { q: "CSS stands for?", a: "Cascading Style Sheets", e: "CSS styles webpages.", level: "easy" },
  { q: "CSS change text color?", a: "color", e: "Example: color: red;", level: "easy" },
  { q: "CSS change background color?", a: "background-color", e: "Example: background-color: blue;", level: "easy" },
  { q: "CSS align text center?", a: "text-align: center", e: "Centers text horizontally.", level: "easy" },
  { q: "CSS font size property?", a: "font-size", e: "Example: font-size: 20px;", level: "easy" },
  { q: "CSS for bold text?", a: "font-weight", e: "Example: font-weight: bold;", level: "easy" },
  { q: "CSS for italic text?", a: "font-style", e: "Example: font-style: italic;", level: "easy" },
  { q: "CSS remove underline?", a: "text-decoration: none", e: "Removes link underline.", level: "easy" },
  { q: "CSS make element disappear?", a: "display: none", e: "Removes element from layout.", level: "easy" },
  { q: "CSS hide element but keep space?", a: "visibility: hidden", e: "Element invisible but space remains.", level: "easy" },
  { q: "CSS margin applies to?", a: "outside spacing", e: "Space outside an element.", level: "easy" },
  { q: "CSS padding applies to?", a: "inside spacing", e: "Space inside an element.", level: "easy" },
  { q: "CSS border radius property?", a: "border-radius", e: "Rounded corners.", level: "easy" },
  { q: "CSS z-index affects?", a: "stacking order", e: "Higher = on top.", level: "easy" },
  { q: "CSS display:flex enables?", a: "flexbox layout", e: "Align child items easily.", level: "easy" },
  { q: "CSS position absolute means?", a: "relative to nearest positioned ancestor", e: "Floats anywhere.", level: "easy" },
  { q: "CSS class selector starts with?", a: ".", e: ".menu {}", level: "easy" },
  { q: "CSS ID selector starts with?", a: "#", e: "#title {}", level: "easy" },
  { q: "CSS width: 100% means?", a: "full width of parent", e: "Expands container.", level: "easy" },
  { q: "CSS cursor:pointer does?", a: "turns cursor to hand", e: "Indicates clickable element.", level: "easy" },
  { q: "JS type of null?", a: "object", e: "Old JS quirk.", level: "easy" },
  { q: "JS type of []?", a: "object", e: "Arrays are objects.", level: "easy" },
  { q: "0.1 + 0.2 === 0.3 ?", a: "false", e: "Floating point precision issue.", level: "easy" },
  { q: "[] == 0 ?", a: "true", e: "Empty array converts to 0.", level: "easy" },
  { q: "[] === [] ?", a: "false", e: "Different memory references.", level: "easy" },
  { q: "typeof NaN?", a: "number", e: "NaN is considered a number.", level: "easy" },
  { q: "String to number function?", a: "Number()", e: "Number('12') → 12", level: "easy" },
  { q: "JSON stands for?", a: "JavaScript Object Notation", e: "Data format.", level: "easy" },
  { q: "parse JSON function?", a: "JSON.parse()", e: "String → object.", level: "easy" },
  { q: "stringify JSON function?", a: "JSON.stringify()", e: "Object → string.", level: "easy" },
  { q: "JS let vs var: let is?", a: "block scoped", e: "var is function scoped.", level: "easy" },
  { q: "Which keyword creates constant value?", a: "const", e: "Cannot reassign.", level: "easy" },
  { q: "What does == do?", a: "compares with type conversion", e: "Loose equality.", level: "easy" },
  { q: "What does === do?", a: "compares without conversion", e: "Strict equality.", level: "easy" },
  { q: "Array length of [1,2,3]?", a: "3", e: "3 elements.", level: "easy" },
  { q: "Is JS single-threaded?", a: "yes", e: "One main thread.", level: "easy" },
  { q: "JS operator for string concat?", a: "+", e: "\"a\"+\"b\" = ab", level: "easy" },
  { q: "Convert string to int?", a: "parseInt()", e: "parseInt('10') → 10", level: "easy" },
  { q: "Convert string to float?", a: "parseFloat()", e: "parseFloat('10.5') → 10.5", level: "easy" },
  { q: "Simple sum: 5 + 7 ?", a: "12", e: "Basic addition.", level: "easy" },
  { q: "Simple sum: 10 + 15 ?", a: "25", e: "Basic addition.", level: "easy" },
  { q: "Simple sum: 20 + 30 ?", a: "50", e: "Basic addition.", level: "easy" },
  { q: "Simple sum: 7 + 8 ?", a: "15", e: "Basic addition.", level: "easy" },
  { q: "Simple sum: 12 + 13 ?", a: "25", e: "Basic addition.", level: "easy" },
  { q: "Simple sum: 0 + 0 ?", a: "0", e: "Adding zero.", level: "easy" },
  { q: "Variable declaration in JS?", a: "let", e: "Use let for block-scoped variable.", level: "easy" },
  { q: "Variable declaration for constant?", a: "const", e: "Cannot reassign value.", level: "easy" },
  { q: "Variable declaration for old JS?", a: "var", e: "Function-scoped variable.", level: "easy" },
  { q: "HTML tag for paragraph?", a: "<p>", e: "Paragraph element.", level: "easy" },
  { q: "HTML tag for image alt text?", a: "alt", e: "Alternative text for images.", level: "easy" },
  { q: "CSS property to change font family?", a: "font-family", e: "Example: font-family: Arial;", level: "easy" },
  { q: "JS alert function?", a: "alert()", e: "Shows message box.", level: "easy" },
  { q: "JS console log?", a: "console.log()", e: "Prints in console.", level: "easy" },
  { q: "React component basic syntax?", a: "function ComponentName(){}", e: "Functional component.", level: "easy" },
  { q: "React render element?", a: "ReactDOM.render()", e: "Renders JSX.", level: "easy" },
  { q: "HTML attribute for link href?", a: "href", e: "Hyperlink URL.", level: "easy" },
  { q: "HTML comment syntax?", a: "<!-- comment -->", e: "Comment in HTML.", level: "easy" },
  { q: "CSS comment syntax?", a: "/* comment */", e: "Comment in CSS.", level: "easy" },
  { q: "JS single line comment?", a: "// comment", e: "Single line comment.", level: "easy" },
  { q: "JS multi-line comment?", a: "/* comment */", e: "Multi-line comment.", level: "easy" },
  { q: "JS add two numbers: 5 + 3 ?", a: "8", e: "Basic addition.", level: "easy" },
  { q: "JS subtract two numbers: 10 - 4 ?", a: "6", e: "Basic subtraction.", level: "easy" },
  { q: "JS multiply: 6 * 7 ?", a: "42", e: "Basic multiplication.", level: "easy" },
  { q: "JS divide: 20 / 4 ?", a: "5", e: "Basic division.", level: "easy" },
  { q: "JS modulus: 10 % 3 ?", a: "1", e: "Remainder after division.", level: "easy" },
  { q: "JS variable naming: allowed?", a: "letters, _, $", e: "Cannot start with numbers.", level: "easy" },
  { q: "JS type of 42?", a: "number", e: "Numeric type.", level: "easy" },
  { q: "JS type of 'Hello'?", a: "string", e: "Text type.", level: "easy" },
  { q: "JS type of true?", a: "boolean", e: "True/false value.", level: "easy" },
  { q: "JS type of undefined?", a: "undefined", e: "Unassigned variable.", level: "easy" },
  { q: "JS type of function?", a: "function", e: "Special type.", level: "easy" },
  { q: "React hook for state?", a: "useState", e: "Manages state in components.", level: "easy" },
  { q: "React hook for effects?", a: "useEffect", e: "Runs after render.", level: "easy" },
  { q: "React prop read-only?", a: "yes", e: "Cannot modify props.", level: "easy" },
  { q: "HTML tag to make text italic?", a: "<i>", e: "Renders italic text.", level: "easy" },
  { q: "HTML tag to make underline?", a: "<u>", e: "Renders underlined text.", level: "easy" },
  { q: "HTML tag for line break?", a: "<br>", e: "Breaks line.", level: "easy" },
  { q: "HTML tag for table?", a: "<table>", e: "Table container.", level: "easy" },
  { q: "HTML tag for table header?", a: "<th>", e: "Table header cell.", level: "easy" },
  { q: "HTML tag for div?", a: "<div>", e: "Generic container.", level: "easy" },
  { q: "HTML tag for span?", a: "<span>", e: "Inline container.", level: "easy" },
  { q: "CSS property for text color?", a: "color", e: "Example: color: red;", level: "easy" },
  { q: "CSS property for background color?", a: "background-color", e: "Example: background-color: blue;", level: "easy" },
  { q: "CSS property for font size?", a: "font-size", e: "Example: font-size: 16px;", level: "easy" },
 ];

  const selectRandomQuestions = () => {
    const shuffled = [...allQuestions].sort(() => Math.random() - 0.5);
    return shuffled.slice(0, 10);
  };

  const startGame = () => {
    setQuestions(selectRandomQuestions());
    setCurrentQuestion(0);
    setScore(0);
    setShowResult(false);
    setStarted(true);
    setSecondsLeft(25);
  };

  // Timer
  useEffect(() => {
    if (!started || showResult) return;
    if (secondsLeft === 0) {
      handleSubmit();
      return;
    }
    const t = setTimeout(() => setSecondsLeft(secondsLeft - 1), 1000);
    return () => clearTimeout(t);
  }, [secondsLeft, started, showResult]);

  const handleSubmit = () => {
    const q = questions[currentQuestion];
    const correct = userAnswer.trim().toLowerCase() === q.a.toLowerCase();

    if (correct) setScore(score + 1);

    setShowExplanation(true);

    setTimeout(() => {
      setShowExplanation(false);
      setUserAnswer("");
      setSecondsLeft(25);

      if (currentQuestion + 1 < questions.length) {
        setCurrentQuestion(currentQuestion + 1);
      } else {
        setShowResult(true);
      }
    }, 2000);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !showExplanation) {
      handleSubmit();
    }
  };

  return (
    <div className="coding-puzzle-wrapper">

      {!started ? (
        <div className="welcome-screen">
          <h2>Welcome to Web Dev Quiz</h2>
          <p className="subtitle">Test your knowledge of HTML, CSS, JavaScript, React & backend.</p>

          <h3>📜 Rules:</h3>
          <ul className="rules">
            <li>🔹 10 random questions each round</li>
            <li>🔹 25 seconds per question</li>
            <li>🔹 Answers are case-insensitive</li>
            <li>🔹 Score increases only for correct answers</li>
            <li>🔹 Choosing wisely is better than guessing 😉</li>
          </ul>

          <button className="start-btn" onClick={startGame}>Start Quiz</button>
        </div>
      ) : null}

      {started && !showResult && questions.length > 0 ? (
        <div className="question-card">

          <div className="top-stats">
            <div className="progress-bar">
              <div 
                className="progress" 
                style={{ width: `${((currentQuestion+1)/questions.length)*100}%` }}
              ></div>
            </div>
            <p>⭐ Score: {score}</p>
            <p>⏳ Time: {secondsLeft}s</p>
          </div>

          <h3 className="question">
            {questions[currentQuestion].q}
          </h3>

          <input
            type="text"
            value={userAnswer}
            disabled={showExplanation}
            onKeyDown={handleKeyPress}
            onChange={(e) => setUserAnswer(e.target.value)}
            placeholder="Type your answer..."
          />

          <button 
            onClick={handleSubmit}
            disabled={showExplanation}
          >
            Submit
          </button>

          <p className="q-count">
            Question {currentQuestion + 1} / {questions.length}
          </p>

          {showExplanation && (
            <div className="explanation-box">
              <p>💡 {questions[currentQuestion].e}</p>
            </div>
          )}

        </div>
      ) : null}

      {showResult && (
        <div className="result-box">
          <h2>🎉 Quiz Completed!</h2>
          <h3>Your Score: {score} / {questions.length}</h3>

          {score <= 3 && <p>Keep learning — you’re just starting 😎</p>}
          {score > 3 && score < 7 && <p>Good! You know your basics 👍</p>}
          {score >= 7 && score < 10 && <p>🔥 Great Job! You’re advanced!</p>}
          {score === 10 && <p>🏆 PERFECT SCORE! You're a PRO!</p>}

          <button onClick={startGame}>Play Again</button>
        </div>
      )}
    </div>
  );
}
